import React, { useEffect, useState } from 'react';
import { Sun, Moon } from 'lucide-react';

/**
 * Floating Day/Night theme toggle. Applies a global `.dark` class to the <html>
 * element. Dark mode is achieved via targeted palette overrides in index.css
 * (no CSS filters), so images, logos and brand accents keep their real colors.
 * Preference is persisted in localStorage.
 */
export default function ThemeToggle() {
  const [isDark, setIsDark] = useState(() => {
    try {
      const saved = localStorage.getItem('spw-theme');
      if (saved === 'dark') return true;
      if (saved === 'light') return false;
      return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    } catch (_) {
      return false;
    }
  });

  useEffect(() => {
    const root = document.documentElement;
    if (isDark) {
      root.classList.add('dark');
      localStorage.setItem('spw-theme', 'dark');
    } else {
      root.classList.remove('dark');
      localStorage.setItem('spw-theme', 'light');
    }
  }, [isDark]);

  return (
    <button
      type="button"
      onClick={() => setIsDark((v) => !v)}
      title={isDark ? 'Switch to day mode' : 'Switch to night mode'}
      aria-label="Toggle color theme"
      data-testid="theme-toggle"
      className="fixed bottom-6 right-6 z-[9999] flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-br from-[#0f2444] via-[#1e3a63] to-[#26518c] text-white shadow-lg transition-transform hover:scale-110 focus:outline-none focus:ring-2 focus:ring-[#5b93d6] focus:ring-offset-2"
    >
      {isDark ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
    </button>
  );
}
